/** One PostHog event, as the model's telemetry builders return it. */
export interface MeasureAnalyticsEvent {
  event: string;
  properties: Record<string, unknown>;
}

/**
 * Sends a measure_tool_* event. PostHog is only set up with analytics consent, so
 * without it (or in tests) this is a no-op; the window.mixpanel facade routes to
 * PostHog too and is always defined, so it is the fallback.
 */
export function sendMeasureEvent(payload: MeasureAnalyticsEvent | null | undefined, target: any = window): void {
  if (!payload) return;
  try {
    if (target?.posthog?.capture) {
      target.posthog.capture(payload.event, payload.properties);
    } else if (target?.mixpanel?.track) {
      target.mixpanel.track(payload.event, payload.properties);
    }
  } catch (error) {
    // Analytics must never break the tool.
  }
}
